import Pusher from 'pusher-js/with-encryption';
import config from 'shared/config/config.js';


var APP_KEY
switch (config.env) {
  case 'production':
    APP_KEY = 'fbba2ac7bf4c4ba05d14';
    break;

  case 'staging':
    APP_KEY = 'eb7460be7b9036bf9eb8';
    break;

  default:
    APP_KEY = 'b46cb25591e56c3118e2';
}

const debugEnabled = config.env !== 'production';
const instrumentedChannels = new Set();

const debugLog = (...args) => {
  if (debugEnabled) {
    console.info('[Pusher]', ...args);
  }
};

const debugWarn = (...args) => {
  if (debugEnabled) {
    console.warn('[Pusher]', ...args);
  }
};

const debugError = (...args) => {
  if (debugEnabled) {
    console.error('[Pusher]', ...args);
  }
};

const pusher = new Pusher(APP_KEY);
debugLog('client created', {
  env: config.env,
  key: APP_KEY
});

if (debugEnabled && pusher.connection) {
  pusher.connection.bind('state_change', states => {
    debugLog('connection state change', states);
  });

  pusher.connection.bind('connected', () => {
    debugLog('connection connected', {
      socketId: pusher.connection.socket_id
    });
  });

  pusher.connection.bind('error', error => {
    debugError('connection error', error);
  });

  pusher.connection.bind('unavailable', () => {
    debugWarn('connection unavailable');
  });

  pusher.connection.bind('failed', () => {
    debugError('connection failed');
  });
}

export const onAccountMessage = (accountId, source, action, callback) => {
  onMessage(`account-${accountId}`, source, action, callback);
}

export const onUserMessage = (userId, source, action, callback) => {
  onMessage(`user-${userId}`, source, action, callback);
}

export const onMessage = (channel, source, action, callback) => {
  let channelInstance = pusher.channel(channel);

  if (!channelInstance) {
    debugLog('subscribing', {
      channel,
      source,
      action
    });
    channelInstance = pusher.subscribe(channel);
  }

  if (!instrumentedChannels.has(channel)) {
    instrumentedChannels.add(channel);

    channelInstance.bind('pusher:subscription_succeeded', () => {
      debugLog('subscription succeeded', {
        channel
      });
    });

    channelInstance.bind('pusher:subscription_error', error => {
      debugError('subscription error', {
        channel,
        error
      });
    });
  }

  channelInstance.bind('pull', msg => {
    debugLog('event received', {
      channel,
      event: 'pull',
      source: msg && msg.source,
      action: msg && msg.action
    });

    if (msg.source === source && msg.action === action) {
      callback(msg);
    }
  });
}

export const unSubChannel = (channel) => {
  debugLog('unsubscribe', {
    channel
  });
  pusher.unsubscribe(channel);
}
